<template>
  <div class="jd-loading-box" :class="{ 'is-overlay':overlay }">
    <div class="loading-img-box">
      <img class="loading-img" :src="$globalCdn + '/images/public/loading.gif'" alt />
    </div>
    <span class="loading-text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: "jd-loading-new",
  props: {
    overlay: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "数据加载中...",
    },
  },
};
</script>

<style lang="scss" scoped>
.jd-loading-box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 500px;
  &.is-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    background: #fff;
    min-height: auto;
  }
  .loading-img-box {
    display: block;
    align-items: center;
    justify-content: center;
    .loading-img {
      width: 33px;
      height: 33px;
      margin: 0 auto 8px;
    }
  }
  .loading-text {
    font-size: 14px;
    width: 100%;
    text-align: center;
    color: #3159FF;
  }
}
</style>
